import { FONT_FAMILY_CONFIG } from 'constants/fonts';
import { FontFamily } from 'types/font.types';

export const getMenuDisplayName = ({
  isMultipleFont = false,
  displayCustomFontFileName = undefined,
  fontFamily,
}: {
  isMultipleFont: boolean;
  displayCustomFontFileName: string | undefined;
  fontFamily: string;
}) => {
  let displayName = isMultipleFont ? 'Multiple Fonts' : displayCustomFontFileName ?? fontFamily;

  // if the font has a displayName in the font config, use that (instead of the font name e.g. for non-en fonts)
  if (FONT_FAMILY_CONFIG[displayName as FontFamily] && FONT_FAMILY_CONFIG[displayName as FontFamily]?.displayName) {
    displayName = FONT_FAMILY_CONFIG[displayName as FontFamily].displayName!;
  }

  return displayName;
};
